import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import S3Upload      from 's3_upload';
import ContentsTab   from 'contents_tab';
import ContentsModal from '@partials/contents-modal';
import PostPreview   from '@common/post-preview/_post-preview';

import ReportEdit    from '@project/contents/report/parts/report-edit';

// -------------------------------------------------------


const REPOST_URL = 'https://casting-admin.s3.ap-northeast-1.amazonaws.com/repost_image/repost.png';

class ProjectReportCandidateModal extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    let data = this.props.data;
    
    let event = data.event; 
    event.showReportCandidateModal = this.showReportCandidateModal.bind(this);
    data.event.updateData.bind(this)('event', event);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal  : false,
      detail : {},
      edit   : {},
      project_id: null,
      insta_user_id: null,
    };
  }
  // -------------------------------------------------------
  
  showReportCandidateModal(project_id, insta_user_id, contents_id) {
    Utils.request.bind(this)('/api/project/influencer/get_report_setting_modal', { project_id: project_id, insta_user_id: insta_user_id },
      function(res){
        
        this.setState({ modal: true, detail: res.body.detail, project_id: project_id, insta_user_id: insta_user_id, contents_id: contents_id });
        
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  saveReport(contents_id, shortcode) {
    
    Utils.request.bind(this)('/api/project/influencer/save_report_setting_modal', { project_id: this.state.project_id, insta_user_id: this.state.insta_user_id, contents_id: contents_id, shortcode: shortcode },
      function(res){
        
        let detail = this.state.detail;
        detail.report = res.body.report;
        detail.report_etc = res.body.report_etc;
        
        let edit = this.state.edit;
        delete edit[contents_id];
        
        this.setState({ detail: detail, edit: edit });
        
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  selectPostEvent(contents_id, shortcode) {
    let edit = this.state.edit;
    edit[contents_id] = shortcode;
    this.setState({ edit: edit });
  }
  // -------------------------------------------------------
  
  detailUpdate(column, value) {
    let detail = this.state.detail;
    detail[column] = value;
    this.setState({ detail: detail });
  }
  // -------------------------------------------------------
  
  closeAssignModal() {
    this.setState({ modal: false, detail: {} });
    this.props.data.event.refreshProject.bind(this)();
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.data;
    
    let detail = this.state.detail;
    detail.event = { select_post_ev: this.selectPostEvent.bind(this), update_ev: this.detailUpdate.bind(this), reflesh_ev: this.showReportCandidateModal.bind(this) }
    detail.edit = Object.assign({}, this.state.edit);
    
    // タブリスト
    let tabs = [];
    try {
      detail.post_contents.map((d) => {
        let pop_mark = true;
        detail.report.map((r) => { if( r.contents_id == d.id ) pop_mark = false; });
        
        // レポート化できない項目を除外
        let set_contents_type = {};
        Const.value.contents_type_list.map((t) => { if( t.id == d.media_type ) set_contents_type = t; });
        if( set_contents_type.report == false ) return;
        
        // タブに追加
        tabs.push({ id: d.id, name: d.name, pop_mark: pop_mark, html: <MainContents base={base} detail={detail} contents_id={d.id} product_type={d.media_type} save_ev={this.saveReport.bind(this)} />});
      });
    } catch(e) {}
    
    let contents_id = this.state.contents_id;
    
    return (
      <div className="project-report-select-modal">
        <ContentsModal
          view      = {this.state.modal}
          width     = {600}
          height    = {500}
          close_ev  = {this.closeAssignModal.bind(this)}
          html      = {
            <div className="modal-item">
              <h2 className="modal-header">レポート用の投稿を設定しましょう</h2>
              
              <ContentsTab select={contents_id} tabs={tabs} font_size={13} className="sub-contents-tab" />
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

class MainContents extends React.Component {
  render() {
    let detail = this.props.detail;
    let contents_id = this.props.contents_id;
    
    // 実投稿を取得
    let mode = null;
    let shortcode = null;
    if( detail.edit[contents_id] != undefined ){ shortcode = detail.edit[contents_id]; mode = 'edit'; }
    
    // 登録済みデータ
    let is_complete = false;
    detail.report.map((d) => {
      if( d.contents_id == contents_id ){
        if( shortcode == null ){ shortcode = d.shortcode; mode = 'complete'; }
        is_complete = true;
      }
    });
    
    // 自動候補選択
    if( shortcode == null ){
      detail.report_select.map((d) => {
        if( d.contents_id == contents_id ){ shortcode = d.shortcode; mode = 'candidate'; }
      });
    }
    
    return (
      <div className="report-candidate-contents">
        <div className="report-candidate-contents-box">
          <ContentsDraft detail={detail} contents_id={this.props.contents_id} product_type={this.props.product_type} />
          <ContentsGenuine base={this.props.base} detail={detail} contents_id={this.props.contents_id} product_type={this.props.product_type} mode={mode} shortcode={shortcode} />
          
          <InsightData detail={detail} contents_id={this.props.contents_id} />
        </div>
        
        { (mode == 'edit') && <h5 className="button-alert">※変更した投稿をレポートの対象にしてもよろしいですか？</h5> }
        { (mode == 'candidate') && <h5 className="button-alert">※自動選択された投稿をレポートの対象にしてもよろしいですか？</h5> }
        
        { (mode == 'edit' || mode == 'candidate')
          ? <div className="button on" onClick={this.props.save_ev.bind(this, contents_id, shortcode)}>レポートに設定する</div>
          : <div className="button off">レポートに設定する</div>
        }
      </div>
    );
  }
}
// -------------------------------------------------------

class ContentsDraft extends React.Component {
  render() {
    let detail = this.props.detail;
    let contents_id = this.props.contents_id;
    
    let caption = '';
    detail.draft_caption.map((d) => { if( d.contents_id == contents_id ) caption = d.caption; });
    
    let media = [];
    detail.draft_media.map((d) => { if( d.contents_id == contents_id ) media.push(d); });
    
    let is_repost = false;
    try { is_repost = (detail.draft.repost.split(',').indexOf(String(contents_id)) >= 0); } catch(e) {}
    
    return (
      <div className="report-candidate-draft">
        <ContentsItem
          title = "下書き"
          mode = "draft"
          data = {{
            media     : media,
            caption   : caption,
            is_repost : is_repost,
          }}
          detail = {detail}
          contents_id = {contents_id}
          product_type = {this.props.product_type}
        />
      </div>
    );
  }
}
// -------------------------------------------------------

class ContentsGenuine extends React.Component {
  render() {
    let detail = this.props.detail;
    
    let mode = this.props.mode;
    let shortcode = this.props.shortcode;
    let product_type = this.props.product_type;
    let contents_id = this.props.contents_id;
    
    // メディアデータの生成
    let caption = '';
    let media = [];
    let score = {};
    let post_date = null;
    let media_url = null;
    
    if( product_type == 'FEED' || product_type == 'REELS' ){
      
      detail.accounts_post.map((d) => {
        if( d.shortcode != shortcode ) return;
        
        score = d;
        caption = d.text;
        post_date = d.post_date;
        media.push({ media_url: d.media_url });
        try { if( data.children != null ) data.children.split(',').map((url) => { media.push({ media_url: url }); }); } catch(e) {}
      });
      
    } else {
      
      detail.report_etc.map((d) => {
        if( d.contents_id != contents_id ) return;
        media_url = ( shortcode != null ) ? shortcode : d.media_url;
        mode = 'complete';
      });
      if( media_url == null && shortcode != null ) media_url = shortcode;
      
    }
    
    return (
      <div className="report-candidate-genuine">
        <ContentsItem
          title = "実投稿"
          mode = {mode}
          data = {{
            media     : media,
            caption   : caption,
            score     : score,
            post_date : post_date,
            media_url : media_url,
          }}
          base = {this.props.base}
          detail = {detail}
          select_shortcode = {shortcode}
          contents_id = {contents_id}
          product_type = {product_type}
          is_change = {true}
        />
      </div>
    );
  }
}
// -------------------------------------------------------

class ContentsItem extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      event              : {},
      preview_modal      : false,
      post_list_modal    : false,
      original_err_modal : false,
    };
  }
  // -------------------------------------------------------
  
  togglePreivewModal(flg) {
    this.setState({ preview_modal: flg });
  }
  // -------------------------------------------------------
  
  toggleListModal(flg) {
    this.setState({ post_list_modal: flg });
  }
  // -------------------------------------------------------
  
  toggleOriginalErrModal(flg) {
    this.setState({ original_err_modal: flg });
  }
  // -------------------------------------------------------
  
  /*
   * イベント設定
   */
  setEvent(column, ev) {
    let event = this.state.event;
    event[column] = ev;
    this.setState({ event: event });
  }
  // -------------------------------------------------------
  
  /*
   * データ更新時反映
   */
  actionProgress() {
    let update_url = null;
    
    let media = this.state.event.get_media.bind(this)();
    media.map((d) => {
      if( update_url == null ) update_url = d.url;
    });
    
    if( update_url != null ) this.props.detail.event.select_post_ev.bind(this)(this.props.contents_id, update_url);
  }
  // -------------------------------------------------------
  
  changeMediaURL() {
    let check = confirm('下書きデータをレポートに反映してもよろしいですか？\n※既に作成済みの場合は上書きされます。ご注意ください。');
    if( check == false ) return;
    
    this.props.detail.event.select_post_ev.bind(this)(this.props.contents_id, this.props.data.media[0].media_url);
  }
  // -------------------------------------------------------
  
  changeRepostURL() {
    let check = confirm('レポートデータをリポストとして登録します。\n※既に作成済みの場合は上書きされます。ご注意ください。');
    if( check == false ) return;
    
    this.props.detail.event.select_post_ev.bind(this)(this.props.contents_id, REPOST_URL);
  }
  // -------------------------------------------------------
  
  deleteReport() {
    let report = this.props.data.report;
    let draft = {};
    
    this.props.detail.draft_media.map((d) => { if( d.contents_id == report.contents_id ) draft = d; });
    
    let chk = confirm('レポートの投稿とコンテンツ（フィード・リールなど）を削除しますか？');
    if( chk == false ) return;
    
    if( Object.keys(draft).length > 0 ){
      let chk2 = confirm('レポートを削除すると付随している下書きデータも削除されます。よろしいですか？\n※削除された下書きは復旧できません。ご注意ください。');
      if( chk2 == false ) return;
    }
    
    Utils.request.bind(this)('/api/project/influencer/delete_report_setting_modal', { project_id: report.project_id, report_id: report.id },
      function(res){
        
        this.props.detail.event.reflesh_ev.bind(this)(report.project_id, report.insta_user_id)
        
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  changeProductType(product_type) {
    let report = this.props.data.report;
    
    Utils.request.bind(this)('/api/project/influencer/change_report_product_type', { project_id: report.project_id, report_id: report.id, product_type: product_type },
      function(res){
        
        this.props.detail.event.reflesh_ev.bind(this)(report.project_id, report.insta_user_id)
        
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let event = this.state.event;
    let product_type = this.props.product_type;
    
    let thumbnail = null;
    if( data.media.length > 0 ) thumbnail = data.media[0].media_url;
    if( thumbnail == null && data.media_url != undefined ) thumbnail = data.media_url;
    
    let is_post = !(thumbnail == null);
    let is_change = (this.props.is_change != undefined);
    
    // レポートの検索
    if( data.report == undefined ) data.report = {};
    try { this.props.detail.report.map((d) => { if( d.contents_id == this.props.contents_id ) data.report = d; }); } catch(e) {}
    try { this.props.detail.report_etc.map((d) => { if( d.contents_id == this.props.contents_id ) data.report = d; }); } catch(e) {}
    
    // オリジナルURLの取得
    let original_url = {};
    try { original_url = this.props.detail.report_original[this.props.contents_id][0]; } catch(e) {}
    
    let original_message = null;
    if( original_url.complete == 0 && original_url.error == 0 ){
      is_change = false;
      original_message = <span>URLから投稿の取得中</span>
    }
    if( data.is_repost == true ){
      original_message = <span>リポスト投稿</span>
    }
    
    // メディア設定
    let is_etc = (product_type == 'FEED' || product_type == 'REELS') ? false : true;
    
    return (
      <div className="report-candidate-item">
        <S3Upload setEvent={this.setEvent.bind(this)} actionProgress={this.actionProgress.bind(this)} />
        
        <h4 className="candidate-title">{this.props.title}</h4>
        
        { (is_post)
          ? <div>
              <div className="image-thumbnail" onClick={this.togglePreivewModal.bind(this, true)}>
                {(thumbnail != null && thumbnail.indexOf('.jpg') !== -1) ? <img src={thumbnail} onError={(e)=>{thumbnail}} /> : null }
                {(thumbnail != null && thumbnail.indexOf('.png') !== -1) ? <img src={thumbnail} onError={(e)=>{thumbnail}} /> : null }
                {(thumbnail != null && Utils.isVideo(thumbnail)) ? <video src={thumbnail} /> : null }
                
                {(this.props.mode == 'complete') && <p className="report-candidate-complete">設定完了</p> }
                {(this.props.mode == 'candidate') && <p className="report-candidate">自動設定</p> }
              </div>
              <h6>※クリックすることで詳細が見れます</h6>
            </div>
          : <div className="not-image-thumbnail">
              {(original_message == null)
                ? <p>{(this.props.mode == 'draft') ? '下書きが未作成です' : '投稿が未選択です' }</p>
                : <p>{original_message}</p>
              }
            </div>
        }
        
        { (this.props.mode != 'complete' && original_url.error === 1) && <div className="button post-select" onClick={this.toggleOriginalErrModal.bind(this, true)}>URL失敗履歴</div> }
        { (is_change) && <div className="button post-select" onClick={this.toggleListModal.bind(this, true)}>{(is_post) ? '投稿を変更' : '投稿を選択' }</div> }
        
        { (is_etc == true && is_change) &&
          <label>
            <input type="file" name="example" size="30" onChange={(e) => { event.file_upload.bind(this)(e, 'posts/etc/') }} />
            <span>メディア登録</span>
          </label>
        }
        
        { (this.props.mode == 'draft' && is_etc == true && is_post == true) && <div className="button post-select" onClick={this.changeMediaURL.bind(this)}>下書きを反映</div> }
        { (this.props.mode == 'draft' && data.is_repost == true) && <div className="button post-select" onClick={this.changeRepostURL.bind(this)}>リポストを反映</div> }
        
        {(this.props.mode == 'complete') && <div className="project-report"><ReportEdit data={this.props.base} target_shortcode={[data.report.shortcode]} /></div> }
        
        {(this.props.mode == 'complete' && this.props.product_type == 'FEED') && <div className="button change-product-type" onClick={this.changeProductType.bind(this, 'REELS')}><i className="material-icons">autorenew</i>リールに変更</div> }
        {(this.props.mode == 'complete' && this.props.product_type == 'REELS') && <div className="button change-product-type" onClick={this.changeProductType.bind(this, 'FEED')}><i className="material-icons">autorenew</i>フィードに変更</div> }
        {(this.props.mode == 'complete') && <div className="button post-delete" onClick={this.deleteReport.bind(this)}><i className="material-icons">delete</i>レポートを削除</div> }
        
        <div className="post-common">
          <PostPreview view={this.state.preview_modal} close_ev={this.togglePreivewModal.bind(this)} detail={data} />
        </div>
        
        <PostListModal
          view={this.state.post_list_modal}
          detail={this.props.detail}
          product_type={this.props.product_type}
          contents_id = {this.props.contents_id}
          select_shortcode={this.props.select_shortcode}
          close_ev={this.toggleListModal.bind(this)}
        />
        
        <OriginalUrlErrorModal
          view={this.state.original_err_modal}
          detail={this.props.detail}
          contents_id = {this.props.contents_id}
          close_ev={this.toggleOriginalErrModal.bind(this)}
        />
      </div>
    );
  }
}
// -------------------------------------------------------

class InsightData extends React.Component {
  render() {
    let detail = this.props.detail;
    let contents_id = this.props.contents_id;
    
    let insight = [];
    detail.insight.map((d) => { if( d.contents_id == contents_id ) insight.push(d); });
    
    console.log(insight);
    return (
      <div className="report-candidate-insight">
        <h2>インサイト提出</h2>
        
        { (insight.length > 0) &&
          <ul>
            { insight.map((d, key) => {
              return (
                <li key={key}>
                  <h6>提出日：{Utils.setDate(d.update_date, 'YYYY年M月D日 HH:mm')}</h6>
                  <p><img src={d.file_url} /></p>
                </li>
              );
            })}
          </ul>
        }
        
        { (insight.length == 0) &&
          <h3 className="none">インサイト未提出です</h3>
        }
      </div>
    );
  }
}
// -------------------------------------------------------

class PostListModal extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal          : false,
      original_modal : false,
      shortcode      : null,
    };
  }
  // -------------------------------------------------------
  
  toggleModal(flg, shortcode) {
    this.setState({ modal: flg, shortcode: shortcode });
  }
  // -------------------------------------------------------
  
  toggleOriginalUrlModal(flg) {
    this.setState({ original_modal: flg });
  }
  // -------------------------------------------------------
  
  itemSelect(shortcode){
    this.props.detail.event.select_post_ev.bind(this)(this.props.contents_id, shortcode);
    this.props.close_ev.bind(this)(false);
  }
  // -------------------------------------------------------
  
  render() {
    if( this.props.view == false ) return null;
    
    let detail = this.props.detail;
    let product_type = this.props.product_type;
    let select_shortcode = this.props.select_shortcode;
    
    // モーダル設定
    let preview = {};
    detail.accounts_post.map((d) => {
      if( d.shortcode != this.state.shortcode ) return;
      
      preview = d;
      preview.caption = d.text;
      preview.media = [];
      preview.media.push({ media_url: d.media_url });
      try { if( data.children != null ) data.children.split(',').map((url) => { media.push({ media_url: url }); }); } catch(e) {}
    });
    detail.accounts_story.map((d) => {
      if( d.post_id != this.state.shortcode ) return;
      
      preview = d;
      preview.caption = d.text;
      preview.media = [];
      preview.media.push({ media_url: d.media_url });
      try { if( data.children != null ) data.children.split(',').map((url) => { media.push({ media_url: url }); }); } catch(e) {}
    });
    
    // 投稿設定
    let posts = [];
    if( product_type == 'STORY' ){
      detail.accounts_story.map((d) => { posts.push(d); });
    } else {
      detail.accounts_post.map((d) => {
        if( d.product_type != product_type ) return;
        posts.push(d);
      });
    }
    
    return (
      <ContentsModal
        view      = {this.props.view}
        width     = {'calc(100% - 150px)'}
        height    = {570}
        max_width = {700}
        close_ev  = {this.props.close_ev.bind(this, false)}
        html      = {
          <div className="report-post-list">
            <h2 className="modal-header">変更したい投稿を選択してください</h2>
            
            { (product_type == 'FEED' || product_type == 'REELS') &&
              <div className="set-original-url" onClick={this.toggleOriginalUrlModal.bind(this, true)}><i className="material-icons">add_link</i>URLから投稿を追加</div>
            }
            
            { (posts.length > 0)
              ? <ul>
                  { posts.map((d, key) => {
                    if( product_type == 'STORY' ){
                      let flg = (d.post_id == select_shortcode) ? 'on' : 'off';
                      
                      return (
                        <li key={key}>
                          <p className="thumbnail" onClick={this.toggleModal.bind(this, true, d.post_id)}><img src={d.thumbnail} /></p>
                          <p className="date">{Utils.setDate(d.post_date, 'YYYY/M/D HH:mm')}</p>
                          <div className="button" onClick={this.itemSelect.bind(this, d.media_url)}>選択</div>
                        </li>
                      );
                    }
                    
                    if( product_type == 'FEED' || product_type == 'REELS' ){
                      let flg = (d.shortcode == select_shortcode) ? 'on' : 'off';
                      
                      return (
                        <li key={key}>
                          <p className="thumbnail" onClick={this.toggleModal.bind(this, true, d.shortcode)}><img src={d.thumbnail} /></p>
                          <p className="date">{Utils.setDate(d.post_date, 'YYYY/M/D HH:mm')}</p>
                          <div className="button" onClick={this.itemSelect.bind(this, d.shortcode)}>選択</div>
                        </li>
                      );
                    }
                    
                  })}
                </ul>
              : <div className="none">投稿がありません</div>
            }
            
            <PostPreview view={this.state.modal} close_ev={this.toggleModal.bind(this)} detail={{
              media     : preview.media,
              caption   : preview.caption,
              score     : preview,
              post_date : preview.post_date,
            }} />
            
            <PostOriginalUrlModal
              view={this.state.original_modal}
              detail={detail}
              contents_id={this.props.contents_id}
              close_ev={this.toggleOriginalUrlModal.bind(this)}
              parent_close_ev={this.props.close_ev.bind(this)}
            />
          </div>
        }
      />
    );
  }
}
// -------------------------------------------------------

class PostOriginalUrlModal extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      check : false,
    };
  }
  // -------------------------------------------------------
  
  changeUrl() {
    this.setState({ check: (this.url.value != '') });
  }
  // -------------------------------------------------------
  
  submit() {
    let detail = this.props.detail;
    
    Utils.request.bind(this)('/api/project/influencer/save_report_original_url', { project_id: detail.project_id, insta_user_id: detail.insta_user_id, url: this.url.value, contents_id: this.props.contents_id },
      function(res){
        alert('投稿URLを設定しました。\nURLの精査に時間が掛かります。しばらくしてから確認をお願いします。');
        this.props.close_ev.bind(this)(false);
        this.props.parent_close_ev.bind(this)(false);
        
        this.props.detail.event.update_ev.bind(this)('report_original', res.body.report_original);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    if( this.props.view == false ) return null;
    
    return (
      <ContentsModal
        view      = {this.props.view}
        width     = {500}
        height    = {140}
        close_ev  = {this.props.close_ev.bind(this, false)}
        html      = {
          <div className="original-url-modal">
            <h3 className="modal-header">URLから投稿を追加</h3>
            
            <input className="text" type="text" ref={(input) => { this.url = input }} onChange={this.changeUrl.bind(this)} placeholder="投稿のURLを入力" />
            
            { (this.state.check == false)
              ? <div className="button off">送信</div>
              : <div className="button" onClick={this.submit.bind(this)}>送信</div>
            }
          </div>
        }
      />
    );
  }
}
// -------------------------------------------------------

class OriginalUrlErrorModal extends React.Component {
  render() {
    if( this.props.view == false ) return null;
    
    // オリジナルURLの取得
    let original_urls = [];
    try { original_urls = this.props.detail.report_original[this.props.contents_id]; } catch(e) {}
    
    return (
      <ContentsModal
        view      = {this.props.view}
        width     = {'calc(100% - 100px'}
        height    = {600}
        close_ev  = {this.props.close_ev.bind(this, false)}
        html      = {
          <div className="original-url-error-modal">
            <h3 className="modal-header">URLから投稿を追加</h3>
            
            <ul>
              { original_urls.map((d, key) => {
                return (
                  <li key={key}>
                    <p className="date">登録日：{Utils.setDate(d.register_date, 'YYYY/M/D HH:mm')}</p>
                    <p className="url"><a href={d.original_url} target="_blank">{d.original_url}</a></p>
                    <p className="detail">{(d.shortcode == null) ? '設定したURLに誤りがあります' : 'Instagram側でデータの取得に失敗しました' }</p>
                  </li>
                );
              })}
            </ul>
          </div>
        }
      />
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProjectReportCandidateModal;